// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { QuestionnaireQuestionChoiceFragmentDoc } from './QuestionnaireQuestionChoice.fragment.generated';
import { QuestionnaireQuestionPriceFragmentDoc } from './QuestionnaireQuestionPrice.fragment.generated';
import { QuestionnaireQuestionTextFragmentDoc } from './QuestionnaireQuestionText.fragment.generated';
export const QuestionnaireQuestionFragmentDoc = gql`
    fragment questionnaireQuestion on QuestionnaireQuestion {
  __typename
  id
  title
  required
  ...questionnaireQuestionChoice
  ...questionnaireQuestionPrice
  ...questionnaireQuestionText
}
    ${QuestionnaireQuestionChoiceFragmentDoc}
${QuestionnaireQuestionPriceFragmentDoc}
${QuestionnaireQuestionTextFragmentDoc}`;